//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import {createRoot, hydrateRoot} from 'react-dom/client';
import AppRoot from './AppRoot';

//---------------------------------------------------------
// Initialization & Entry Point
//---------------------------------------------------------
const initializeApp = () => {
	const rootElement = document.getElementById('root');
	if (!rootElement) throw new Error('Root element not found');

	const app = <AppRoot />;

	if (rootElement.hasChildNodes()) hydrateRoot(rootElement, app);
	else createRoot(rootElement).render(app);
};

initializeApp();
